// DeleteUser.jsx
import React from 'react';
import { Text } from '@mantine/core';

function DeleteUser() {
  return (
    <div style={{ padding: '1rem' }}>
      <Text size="xl" weight={500}>
        Delete User Page
      </Text>
    </div>
  );
}

export default DeleteUser;
